// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1MrdQ","header":"ClearentDisclaimer_header__3eQGl","inner":"ClearentDisclaimer_inner__3vUpF"};